import { render, staticRenderFns } from "./ImportOrderTemplateDetail.vue?vue&type=template&id=6f43950f"
import script from "./ImportOrderTemplateDetail.vue?vue&type=script&lang=js"
export * from "./ImportOrderTemplateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports